<!-- eslint-disable @intlify/vue-i18n/no-raw-text -->
<template>
  <v-main>
    <v-container fluid>
      <v-row density="comfortable">
        <v-cols>
          <sf-title>Storefront UI-Komponenten</sf-title>
        </v-cols>
      </v-row>
      <v-row density="comfortable">
        <v-cols>
          <v-table>
            <tbody>
              <tr>
                <td colspan="5">
                  <sf-sub-heading> Typografie <code>src/components/text</code> </sf-sub-heading>
                </td>
              </tr>
              <tr>
                <td style="width: 10%">Titel</td>
                <td><code>SfTitle</code></td>
                <td><sf-title>Titel</sf-title></td>
                <td>
                  <code>{{ sfTitleCode }}</code>
                </td>
                <td style="width: 20%">
                  Klassen: <br /><code>text-headline-small text-high-emphasis</code>
                </td>
              </tr>
              <tr>
                <td>Überschriften</td>
                <td><code>SfHeading</code></td>
                <td><sf-heading>Überschrift</sf-heading></td>
                <td>
                  <code>{{ sfHeadingCode }}</code>
                </td>
                <td>
                  Klassen: <br />
                  <code>text-body-1 font-weight-bold text-high-emphasis</code>
                </td>
              </tr>
              <tr>
                <td>Sub-Überschriften</td>
                <td><code>SfSubHeading</code></td>
                <td>
                  <sf-sub-heading>Sub Überschrift</sf-sub-heading>
                </td>
                <td>
                  <code>{{ sfSubHeadingCode }}</code>
                </td>
                <td>
                  Klassen: <br />
                  <code>text-body-1 font-weight-medium text-high-emphasis</code>
                </td>
              </tr>
              <tr>
                <td>Fließtext</td>
                <td><code>SfText</code></td>
                <td>
                  <sf-text
                    >Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod
                    tempor invidunt ut labore et dolore magna aliquyam erat, sed diam
                    voluptua.</sf-text
                  >
                </td>
                <td>
                  <code>{{ sfTextCode }}</code>
                </td>
                <td>
                  Klassen: <br />
                  <code>text-body-1 text-high-emphasis</code>
                </td>
              </tr>
              <tr>
                <td>Sekundärer Text</td>
                <td><code>SfSecondaryText</code></td>
                <td>
                  <sf-secondary-text>Sekundärer Text</sf-secondary-text>
                </td>
                <td>
                  <code>{{ sfSecondaryTextCode }}</code>
                </td>
                <td>
                  Klassen: <br />
                  <code>text-body-2 text-high-emphasis</code>
                </td>
              </tr>
              <tr>
                <td>Farbiger Text</td>
                <td><code>SfColorText</code></td>
                <td>
                  <sf-color-text color="red">Farbiger Text</sf-color-text>
                </td>
                <td>
                  <code>{{ sfColorTextCode }}</code>
                </td>
                <td>
                  Klassen: <br />
                  <code>text-body-1 font-weight-medium</code><br />
                  Parameter: <br />
                  <code>color</code> (Pflicht)
                </td>
              </tr>
              <tr>
                <td>Link</td>
                <td><code>SfLink</code></td>
                <td>
                  <sf-link href="https://www.itscope.com">Link</sf-link>
                </td>
                <td>
                  <code>{{ sfLinkCode }}</code>
                </td>
                <td>
                  Klassen: <br />
                  <code>text-primary text-decoration-none</code><br />
                  Link wird immer in neuen Tab geöffnet
                </td>
              </tr>
              <tr>
                <td colspan="5">
                  <sf-sub-heading> Buttons <code>src/components/buttons</code> </sf-sub-heading>
                </td>
              </tr>
              <tr>
                <td>Button</td>
                <td><code>SfButton</code></td>
                <td>
                  <sf-button>Button</sf-button>
                </td>
                <td>
                  <code>{{ sfButtonCode }}</code>
                </td>
                <td>Farbe: <code>primary</code></td>
              </tr>
              <tr>
                <td>Großer Button</td>
                <td><code>SfLargeButton</code></td>
                <td>
                  <sf-large-button class="my-1">Großer Button</sf-large-button>
                </td>
                <td>
                  <code>{{ sfLargeButtonCode }}</code>
                </td>
                <td>
                  <code>SfButton</code> plus <code>x-large</code> als Parameter und
                  <code>text-headline-small</code> als Klasse
                </td>
              </tr>
              <tr>
                <td>Text Button</td>
                <td><code>SfTextButton</code></td>
                <td>
                  <sf-text-button>Text Button</sf-text-button>
                </td>
                <td>
                  <code>{{ sfTextButtonCode }}</code>
                </td>
                <td>
                  Klassen:<br />
                  <code>text-body-1 font-weight-medium</code><br />
                  Gesetzte Parameter: <br /><code>text: true</code> und
                  <code>color: 'primary'</code>
                </td>
              </tr>
              <tr>
                <td>Icon Button</td>
                <td><code>SfIconButton</code></td>
                <td>
                  <sf-icon-button :icon="mdiFlag" />
                </td>
                <td>
                  <code>{{ sfIconButtonCode }}</code>
                </td>
                <td>
                  Gesetzte Parameter: <br /><code>icon: true</code> und <code>color: 'primary'</code
                  ><br />
                  Valider
                  <sf-link href="https://pictogrammers.com/library/mdi/"
                    >Material Design Icons</sf-link
                  >
                  Key nutzen
                </td>
              </tr>
              <tr>
                <td>Editieren Button</td>
                <td><code>SfEditButton</code></td>
                <td>
                  <sf-edit-button />
                </td>
                <td>
                  <code>{{ sfEditButtonCode }}</code>
                </td>
                <td><code>SfIconButton</code> mit <code :icon="mdiPencil" /> als Icon</td>
              </tr>
              <tr>
                <td>Löschen Button</td>
                <td><code>SfDeleteButton</code></td>
                <td>
                  <sf-delete-button />
                </td>
                <td>
                  <code>{{ sfDeleteButtonCode }}</code>
                </td>
                <td><code>SfIconButton</code> mit <code :icon="mdiTrashCanOutline" /> als Icon</td>
              </tr>
              <tr>
                <td colspan="5">
                  <sf-sub-heading>
                    Alerts
                    <code>src/components/alerts</code>
                  </sf-sub-heading>
                </td>
              </tr>
              <tr>
                <td>Basis Alert</td>
                <td><code>SfAlertBase</code></td>
                <td>
                  <sf-alert-base class="mt-2">Basis</sf-alert-base>
                </td>
                <td>
                  <code>{{ sfAlertBaseCode }}</code>
                </td>
                <td>Basis-Komponente für die anderen Alerts</td>
              </tr>
              <tr>
                <td>Info Alert</td>
                <td><code>SfAlertInfo</code></td>
                <td>
                  <sf-alert-info class="mt-2">Info</sf-alert-info>
                </td>
                <td>
                  <code>{{ sfAlertInfoCode }}</code>
                </td>
                <td>
                  <code :icon="mdiInformationOutline" /><br />
                  <code>type: 'info'</code><br />
                  <code>color: 'blue-grey'</code><br />
                </td>
              </tr>
              <tr>
                <td>Erfolgreich Alert</td>
                <td><code>SfAlertSuccess</code></td>
                <td>
                  <sf-alert-success class="mt-2">Erfolgreich</sf-alert-success>
                </td>
                <td>
                  <code>{{ sfAlertSuccessCode }}</code>
                </td>
                <td>
                  <code :icon="mdiCheckCircleOutline" /><br />
                  <code>type: 'success'</code><br />
                </td>
              </tr>
              <tr>
                <td>Warnung Alert</td>
                <td><code>SfAlertWarning</code></td>
                <td>
                  <sf-alert-warning class="mt-2">Warnung</sf-alert-warning>
                </td>
                <td>
                  <code>{{ sfAlertWarningCode }}</code>
                </td>
                <td>
                  <code :icon="mdiAlertOutline" /><br />
                  <code>type: 'warning'</code><br />
                  <code>color: 'deep-orange'</code><br />
                </td>
              </tr>
              <tr>
                <td>Fehler Alert</td>
                <td><code>SfAlertError</code></td>
                <td>
                  <sf-alert-error class="mt-2">Fehler</sf-alert-error>
                </td>
                <td>
                  <code>{{ sfAlertErrorCode }}</code>
                </td>
                <td>
                  <code :icon="mdiAlertOctagonOutline" /><br />
                  <code>type: 'error'</code><br />
                </td>
              </tr>
            </tbody>
          </v-table>
        </v-cols>
      </v-row>
    </v-container>
  </v-main>
</template>

<script lang="ts">
import SfAlertBase from '@/components/alerts/SfAlertBase.vue'
import SfAlertError from '@/components/alerts/SfAlertError.vue'
import SfAlertInfo from '@/components/alerts/SfAlertInfo.vue'
import SfAlertSuccess from '@/components/alerts/SfAlertSuccess.vue'
import SfAlertWarning from '@/components/alerts/SfAlertWarning.vue'
import SfButton from '@/components/button/SfButton.vue'
import SfDeleteButton from '@/components/button/SfDeleteButton.vue'
import SfEditButton from '@/components/button/SfEditButton.vue'
import SfIconButton from '@/components/button/SfIconButton.vue'
import SfLargeButton from '@/components/button/SfLargeButton.vue'
import SfTextButton from '@/components/button/SfTextButton.vue'
import SfColorText from '@/components/text/SfColorText.vue'
import SfHeading from '@/components/text/SfHeading.vue'
import SfLink from '@/components/text/SfLink.vue'
import SfSecondaryText from '@/components/text/SfSecondaryText.vue'
import SfSubHeading from '@/components/text/SfSubHeading.vue'
import SfText from '@/components/text/SfText.vue'
import SfTitle from '@/components/text/SfTitle.vue'
import { useTitle } from '@/helpers'
import {
  mdiAlertOutline,
  mdiCheckCircleOutline,
  mdiFlag,
  mdiInformationOutline,
  mdiPencil,
  mdiTrashCanOutline,
  mdiAlertOctagonOutline
} from '@mdi/js'
import { defineComponent, ref } from 'vue'

export default defineComponent({
  name: 'UiComponentsPage',
  components: {
    SfTitle,
    SfHeading,
    SfSubHeading,
    SfText,
    SfButton,
    SfTextButton,
    SfLargeButton,
    SfIconButton,
    SfEditButton,
    SfDeleteButton,
    SfLink,
    SfColorText,
    SfAlertWarning,
    SfAlertInfo,
    SfAlertError,
    SfAlertSuccess,
    SfSecondaryText,
    SfAlertBase
  },
  setup() {
    useTitle(ref('Storefront UI-Komponenten'))

    const sfTitleCode = '<sf-title>Titel</sf-title>'
    const sfHeadingCode = '<sf-heading>Überschrift</sf-heading>'
    const sfSubHeadingCode = '<sf-sub-heading>Sub Überschrift</sf-sub-heading>'
    const sfTextCode =
      '<sf-text>Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua.</sf-text>'
    const sfSecondaryTextCode = '<sf-secondary-text>Sekundärer Text</sf-secondary-text>'
    const sfColorTextCode = '<sf-color-text color="red">Farbiger Text</sf-color-text>'
    const sfLinkCode = '<sf-link href="https://www.itscope.com">Link</sf-link>'
    const sfButtonCode = '<sf-button>Button</sf-button>'
    const sfLargeButtonCode = '<sf-large-button>Großer Button</sf-large-button>'
    const sfTextButtonCode = '<sf-text-button>Text Button</sf-text-button>'
    const sfIconButtonCode = '<sf-icon-button :icon="mdiFlag"> </sf-icon-button>'
    const sfEditButtonCode = '<sf-edit-button />'
    const sfDeleteButtonCode = '<sf-delete-button />'
    const sfAlertBaseCode = '<sf-alert-base>Basis</sf-alert-base>'
    const sfAlertInfoCode = '<sf-alert-info>Info</sf-alert-info>'
    const sfAlertSuccessCode = '<sf-alert-success>Erfolgreich</sf-alert-success>'
    const sfAlertWarningCode = '<sf-alert-warning>Warnung</sf-alert-warning>'
    const sfAlertErrorCode = '<sf-alert-error>Fehler</sf-alert-error>'

    return {
      sfTitleCode,
      sfHeadingCode,
      sfSubHeadingCode,
      sfTextCode,
      sfSecondaryTextCode,
      sfColorTextCode,
      sfLinkCode,
      sfButtonCode,
      sfLargeButtonCode,
      sfTextButtonCode,
      sfIconButtonCode,
      sfEditButtonCode,
      sfDeleteButtonCode,
      sfAlertBaseCode,
      sfAlertInfoCode,
      sfAlertSuccessCode,
      sfAlertWarningCode,
      sfAlertErrorCode,
      mdiPencil,
      mdiTrashCanOutline,
      mdiFlag,
      mdiAlertOutline,
      mdiCheckCircleOutline,
      mdiInformationOutline,
      mdiAlertOctagonOutline
    }
  }
})
</script>
